<template>
    <div class="box">
        <div class="box-content">
            <datepicker input-class="form-control" v-model="date_filter_start"></datepicker>
            <datepicker input-class="form-control" v-model="date_filter_end"></datepicker>
        </div>
    </div>
</template>

<script>
  import Datepicker from 'vuejs-datepicker';

  export default {
    props: [
      'logged_in_user',
      'users',
      'system_types',
      'statuses',
    ],
    components: {
      'datepicker': Datepicker,
    },
    data() {
      return {
        date_filter_start: null,
        date_filter_end: null,
        user_filter: null,
        status_filter: null,
        system_filter: null,
        type_filter: null,
      }
    },
    methods: {
    },
  };
</script>
